/**
 * Feature flags for the legacy (class-based) webapp flow.
 * Flip these when re-enabling a temporarily disabled feature.
 */
export const ALLOW_SCHEDULE_FOR_LATER = false;
